module.exports = __webpack_public_path__ + "static/media/PoemTypeImg.5660619c.jpg";